export default function(obj, _Vdt, blocks, $callee) {
    _Vdt || (_Vdt = Vdt);
    obj || (obj = {});
    blocks || (blocks = {});
    var h = _Vdt.miss.h, hc = _Vdt.miss.hc, hu = _Vdt.miss.hu, widgets = this && this.widgets || {}, _blocks = {}, __blocks = {},
        __u = _Vdt.utils, extend = __u.extend, _e = __u.error, _className = __u.className, __slice = __u.slice, __noop = __u.noop,
        __m = __u.map, __o = __u.Options, _getModel = __o.getModel, _setModel = __o.setModel,
        _setCheckboxModel = __u.setCheckboxModel, _detectCheckboxChecked = __u.detectCheckboxChecked,
        _setSelectModel = __u.setSelectModel,
        self = this.data, $this = this, scope = obj, Animate = self && self.Animate, parent = ($callee || {})._super;

    const {children, label, _card, className, key, ref, ...rest} = self.get();

    return h('div', {
        ...function() {try {return (rest )} catch(e) {_e(e)}}.call($this)
    }, [
        function() {try {return (!_card )} catch(e) {_e(e)}}.call($this) ?
            h('div', null, (_blocks['label'] = function(parent) {
                return function() {try {return (label )} catch(e) {_e(e)}}.call($this);
            }) && (__blocks['label'] = function(parent) {
                var args = arguments;
                return blocks['label'] ? blocks['label'].apply($this, [function() {
                    return _blocks['label'].apply($this, args);
                }].concat(__slice.call(args, 1))) : _blocks['label'].apply($this, args);
            }) && __blocks['label'].apply($this, [__noop]), 'k-label') :
            undefined,
        function() {try {return (children )} catch(e) {_e(e)}}.call($this)
    ], _className(function() {try {return ({"k-group": true, [className]: className} )} catch(e) {_e(e)}}.call($this)))
}